import { useGLTF } from "@react-three/drei";
import { useLoader } from "@react-three/fiber";
import * as THREE from "three";
import { useEffect, useRef } from "react";

export default function CustomGltf({ src, ...props }) {
  const gltf = useGLTF(src);

  const matcapTexture = useLoader(
    THREE.TextureLoader,
    new URL("/white_matcap.webp", import.meta.url).href,
  );

  const matCap = new THREE.MeshMatcapMaterial({
    matcap: matcapTexture,
  });

  const standardMaterial = new THREE.MeshStandardMaterial({
    color: "white",
  });
  const normalMaterial = new THREE.MeshNormalMaterial();
  const groupRef = useRef();

  useEffect(() => {
    if (!gltf || !groupRef.current) return;

    groupRef.current.traverse((child) => {
      if (child.isMesh) {
        child.material = matCap;
        child.castShadow = true;
        child.receiveShadow = true;
        child.material.flatShading = false;
        child.material.side = THREE.DoubleSide;

        const hasWireframe = child.children.some((c) => c.name === "wireframe");
        if (!hasWireframe && child.geometry) {
          const wireframeGeom = new THREE.WireframeGeometry(child.geometry);
          const lineMat = new THREE.LineBasicMaterial({
            color: 0x000000,
            transparent: true,
            opacity: 0.1,
          });
          const wireframe = new THREE.LineSegments(wireframeGeom, lineMat);
          wireframe.name = "wireframe";
          child.add(wireframe);
        }
      }
    });
  }, [gltf.scene, matCap]);

  return (
    <>
      <ambientLight intensity={10} />
      <group ref={groupRef} {...props}>
        <primitive object={gltf.scene} />
      </group>
    </>
  );
}
